// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-container table {
  width: 100%;
  border-collapse: collapse;
}

.markdown-container th,
.markdown-container td {
  border: 1px solid black;
  padding: 8px;
  text-align: left;
}

.markdown-container th {
  background-color: #f4f4f4;
}
`, "",{"version":3,"sources":["webpack://./src/components/markdown-render/MarkdownStyles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".markdown-container table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.markdown-container th,\n.markdown-container td {\n  border: 1px solid black;\n  padding: 8px;\n  text-align: left;\n}\n\n.markdown-container th {\n  background-color: #f4f4f4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
